import React, { lazy, Suspense } from "react";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import PageLoader from "@/components/PageLoader";
import PendingBusinessEdit from "@/pages/PendingBusinessEdit";
import ListingRequest from "@/pages/ListingRequest/ListingRequest";
import ListingRequestView from "@/pages/ListingRequest/ListingRequestView";
import CategoryPage from "@/pages/Category/Category";


const Dashboard = lazy(() =>
  import(/*webpackChunkName:'DashboardPage'*/ "@/pages/Dashboard")
);
const Admin = lazy(() =>
  import(/*webpackChunkName:'AdminPage'*/ "@/pages/Admin/Admin")
);

const User = lazy(() =>
  import(/*webpackChunkName:'CustomerPage'*/ "@/pages/User/User")
);
const PendingUser = lazy(() =>
  import(/*webpackChunkName:'CustomerPage'*/ "@/pages/PendingUser")
);
const PendingBusiness = lazy(() =>
  import(/*webpackChunkName:'CustomerPage'*/ "@/pages/PendingBusiness")
);
const PendingBusinessList = lazy(() =>
  import(/*webpackChunkName:'CustomerPage'*/ "@/pages/PendingBusinessList")
);
const Category = lazy(() =>
  import(/*webpackChunkName:'CustomerPage'*/ "@/pages/Category")
);





const Logout = lazy(() =>
  import(/*webpackChunkName:'LogoutPage'*/ "@/pages/Logout")
);
// const NotFound = lazy(() =>
//   import(/*webpackChunkName:'NotFoundPage'*/ "@/pages/NotFound")
// );


import UserLogin from "../components/UserView/Login/login";
import UserRegister from "../components/UserView/Login/register";
import Howitworks from "../components/UserView/Howitworks/howitworks";
import Aboutus from "../components/UserView/Aboutus/aboutus";
import Directory from "@/pages/Directory/Directory";
import Report from "@/pages/Report/Report";
import UserView from "@/pages/User/UserView";
import UserEdit from "@/pages/User/UserEdit";
import AdminNotification from "../pages/Notification/Notification";
//import ChangePassword from "@/pages/Changepassword";
//import UserDashboard from "@/components/UserView/UserDashboard/userDashboard";

 import Changepassword from "@/pages/Admin/ChangePassword";
 import ResetPassword from "@/pages/Admin/ResetPassword";



export default function AppRouter() {
 
  const location = useLocation();
  
  return (
    
    <Suspense fallback={<PageLoader />}>
      <AnimatePresence exitBeforeEnter initial={false}>
        <Switch location={location} key={location.pathname}>
          <PrivateRoute path="/admin/dashboard" component={Dashboard} exact />
          <PrivateRoute path="/admin" component={Dashboard} exact />
          <PrivateRoute component={User} path="/admin/admin-panel/user" exact />
          <PrivateRoute component={Directory} path="/admin/admin-panel/directory" exact />
          <PrivateRoute component={AdminNotification} path="/admin/notification/:id" exact />
          <PrivateRoute component={AdminNotification} path="/admin/admin-panel/notification/:id" exact />
          <PrivateRoute component={Report} path="/admin/admin-panel/report" exact />
          <PrivateRoute component={UserView} path="/admin/admin-panel/user/view/:id" exact />
          <PrivateRoute component={UserEdit} path="/admin/admin-panel/user/edit/:id" exact />
          <PrivateRoute component={ListingRequest} path="/admin/admin-panel/listing-request"  exact />
          <PrivateRoute component={CategoryPage} path="/admin/admin-panel/category"  exact />
         <PrivateRoute component={Changepassword} path="/admin/admin-panel/change-password"  exact /> 
          <PrivateRoute component={Admin} path="/admin/admin-panel/admins" exact/>
          <PrivateRoute component={ResetPassword} path="/ResetPassword" exact/>

          
         
          

          <PrivateRoute component={Category} path="/category" exact />
          <PrivateRoute component={PendingUser} path="/pending-user" exact />
          <PrivateRoute component={PendingBusiness} path="/pending-business" exact />
          <Route path="/pending-business/view/:id" component={PendingBusinessList} />
          <Route path="/pending-business/edit/:id" component={PendingBusinessEdit} />
          <Route path="/listing-request/view/:id" component={ListingRequestView} />
          {/* <Route path="/pending-business/edit/:id" component={PendingBusinessEdit} /> */}

          <PrivateRoute component={Logout} path="/logout" exact />
          <PublicRoute path="/admin/login" render={() => <Redirect to="/admin/dashboard" />} />
          {/* <PublicRoute component={UserRegister} path="/user-register" exact/> */}
          <Route component={UserLogin} path="/login" exact />
          {/* <PublicRoute component={UserDashboard} path="/user-dashboard" exact/> */}
          <Route component={Aboutus} path="/aboutus" exact/>
          <Route component={Howitworks} path="/how-it-works" exact/>
          
        </Switch>
      </AnimatePresence>
    </Suspense>
  );
}
